import { Link } from 'react-router-dom';
import { ArrowUpRight, Layers3, ParkingSquare, Route, Pickaxe, AlignVerticalJustifyEnd, ScanLine } from 'lucide-react';
const icons = { layers: Layers3, parking: ParkingSquare, route: Route, remove: Pickaxe, overlay: AlignVerticalJustifyEnd, precision: ScanLine };

export const ServiceCard = ({ service, index, prefix = 'service-card' }) => {
  const Icon = icons[service.icon];
  return <Link to={`/services/${service.slug}/`} className="service-card" data-testid={`${prefix}-${service.slug}`}>
    <div className="service-card-top"><Icon size={26} strokeWidth={1.5} aria-hidden="true" /><span>{String(index + 1).padStart(2, '0')}</span></div>
    <h3>{service.title}</h3><p>{service.summary}</p><span className="card-link">Explore service<ArrowUpRight size={18} aria-hidden="true" /></span>
  </Link>;
};